import { render, staticRenderFns } from "./product-category-filters.vue?vue&type=template&id=40561a48&scoped=true"
import script from "./product-category-filters.vue?vue&type=script&lang=js"
export * from "./product-category-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40561a48",
  null
  
)

export default component.exports